<template>
  <div id="Blossom"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'

import defaultValue from "@/utils/defaultValue"
import colorTool from "@/utils/colorTool"

const {defaultWidth, defaultHeight} = defaultValue()


const props = defineProps(['currentValue', 'effectTheme'])
const {rgbToHsb, changeToRgb} = colorTool()


const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let colorLow = ref([])
let colorHigh = ref([])
let nowTemperature = ref(null)
let high = ref(null)
let low = ref(null)
let backgroundColor = ref('rgb(0,0,0)')
let drawPot = ref(0)
let animateSpeed = ref(10)
let currentColorArr = reactive({arr: []})



const handleGetAnimateHSBAndSpeed = (high, low, now = 10, colorHigh, colorLow) => {

  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 10) // 將高低差 分為 10個單位, 1單位


  let lowHeightColorRange

  let range = Math.trunc((now - low) / lowHeightRange)

  // 設定速度
  if (range <= 0) {
    animateSpeed.value = 30
    lowHeightColorRange = 1
  }
  else if (range >= 10 ) {
    animateSpeed.value = 110
    lowHeightColorRange = 10
  }
  else {
    animateSpeed.value = 30 + (7 * range)
    lowHeightColorRange = range
  }


  if (lowHeightColorRange === 1 ) currentColorArr.arr = colorLow.map(color => rgbToHsb(color))
  else if (lowHeightColorRange >= 10) currentColorArr.arr = colorHigh.map(color => rgbToHsb(color))
  else {
    const colorHighOne = rgbToHsb(colorHigh[0])
    const colorHighTwo = rgbToHsb(colorHigh[1])
    const colorHighThree = rgbToHsb(colorHigh[2])
    const colorHighFour = rgbToHsb(colorHigh[3])
    const colorHighFive = rgbToHsb(colorHigh[4])

    const colorLowOne = rgbToHsb(colorLow[0])
    const colorLowTwo = rgbToHsb(colorLow[1])
    const colorLowThree = rgbToHsb(colorLow[2])
    const colorLowFour = rgbToHsb(colorLow[3])
    const colorLowFive = rgbToHsb(colorLow[4])

    // 新的顏色H = (1 * H1 + 9 * H2) / 10
    // 新的顏色S = (1 * S1 + 9 * S2) / 10
    // 新的顏色B = (1 * B1 + 9 * B2) / 10

    const nowColorOne = [
      (lowHeightColorRange * colorHighOne[0] + (10 - lowHeightColorRange) * colorLowOne[0]) / 10,
      (lowHeightColorRange * colorHighOne[1] + (10 - lowHeightColorRange) * colorLowOne[1]) / 10,
      (lowHeightColorRange * colorHighOne[2] + (10 - lowHeightColorRange) * colorLowOne[2]) / 10,
    ]
    const nowColorTwo = [
      (lowHeightColorRange * colorHighTwo[0] + (10 - lowHeightColorRange) * colorLowTwo[0]) / 10,
      (lowHeightColorRange * colorHighTwo[1] + (10 - lowHeightColorRange) * colorLowTwo[1]) / 10,
      (lowHeightColorRange * colorHighTwo[2] + (10 - lowHeightColorRange) * colorLowTwo[2]) / 10,
    ]
    const nowColorThree = [
      (lowHeightColorRange * colorHighThree[0] + (10 - lowHeightColorRange) * colorLowThree[0]) / 10,
      (lowHeightColorRange * colorHighThree[1] + (10 - lowHeightColorRange) * colorLowThree[1]) / 10,
      (lowHeightColorRange * colorHighThree[2] + (10 - lowHeightColorRange) * colorLowThree[2]) / 10,
    ]
    const nowColorFour = [
      (lowHeightColorRange * colorHighFour[0] + (10 - lowHeightColorRange) * colorLowFour[0]) / 10,
      (lowHeightColorRange * colorHighFour[1] + (10 - lowHeightColorRange) * colorLowFour[1]) / 10,
      (lowHeightColorRange * colorHighFour[2] + (10 - lowHeightColorRange) * colorLowFour[2]) / 10,
    ]
    const nowColorFive = [
      (lowHeightColorRange * colorHighFive[0] + (10 - lowHeightColorRange) * colorLowFive[0]) / 10,
      (lowHeightColorRange * colorHighFive[1] + (10 - lowHeightColorRange) * colorLowFive[1]) / 10,
      (lowHeightColorRange * colorHighFive[2] + (10 - lowHeightColorRange) * colorLowFive[2]) / 10,
    ]

    currentColorArr.arr = [
      nowColorOne,
      nowColorTwo,
      nowColorThree,
      nowColorFour,
      nowColorFive
    ]

    if (
        colorHighOne[0] === colorLowOne[0] &&
        colorHighOne[1] === colorLowOne[1] &&
        colorHighOne[2] === colorLowOne[2]
    ) {
      currentColorArr.arr[0] = colorHighOne
    }
    if (
        colorHighTwo[0] === colorLowTwo[0] &&
        colorHighTwo[1] === colorLowTwo[1] &&
        colorHighTwo[2] === colorLowTwo[2]
    ) {
      currentColorArr.arr[1] = colorHighTwo
    }
    if (
        colorHighThree[0] === colorLowThree[0] &&
        colorHighThree[1] === colorLowThree[1] &&
        colorHighThree[2] === colorLowThree[2]
    ) {
      currentColorArr.arr[2] = colorHighThree
    }
    if (
        colorHighFour[0] === colorLowFour[0] &&
        colorHighFour[1] === colorLowFour[1] &&
        colorHighFour[2] === colorLowFour[2]
    ) {
      currentColorArr.arr[3] = colorHighFour
    }
    if (
        colorHighFive[0] === colorLowFive[0] &&
        colorHighFive[1] === colorLowFive[1] &&
        colorHighFive[2] === colorLowFive[2]
    ) {
      currentColorArr.arr[4] = colorHighFive
    }
  }
}


//////////// select methods ///////////


const centerWidth = ref(300)

const stWidth = ref(8)
let stColor = ref(`rgb(0,0,0)`) //default


const blossomAnimate = (sketch) => {
    let cw = defaultWidth.value
    let ch = defaultHeight.value
    let lines = []
    let linesNum = 50
    const DIST = 10
    let MAX
    const GEN = 30
    sketch.setup = () => {
      // init lines
      lines = []
      sketch.createCanvas(cw, ch);
      sketch.angleMode(sketch.DEGREES);
      sketch.colorMode(sketch.HSB, 360, 100,100, 255);
      MAX = sketch.width > sketch.height ? sketch.width : sketch.height;
      for (let i = 0; i < linesNum; i++) {
        lines.push(new MyLine());
      }
    }

    sketch.draw = () => {
      drawPot.value ++
      sketch.clear();
      sketch.background(backgroundColor.value)
      sketch.noStroke();
      for (let i = 0; i < lines.length; i++) {
        sketch.push();
        sketch.translate( cw / 2, ch / 2);
        sketch.rotate(360 * i / lines.length);
        // lines[i].speed = sketch.random( 2 * animateSpeed.value / 100,  12 * animateSpeed.value / 100)
        lines[i].display(animateSpeed.value);
        sketch.pop();
      }
      sketch.fill(backgroundColor.value);//圓心顏色
      sketch.stroke(stColor.value); //圓 border 顏色
      sketch.strokeWeight(stWidth.value);//圓 border 大小
      sketch.circle(cw / 2, ch / 2, centerWidth.value); //圓 大小 (x座標, y座標, 直徑)
    }

    class MyLine {
        constructor() {
          this.objs = [];
          this.speed = sketch.random( 2 / 100,  12 / 100); // 原始發散速度
          this.h = sketch.random(2, 10);
        }

        display(lineSpeed) {
            if (sketch.random(100) < GEN) {
                if ((this.objs.length == 0) ||
                    (this.objs.length > 0 && this.objs[this.objs.length - 1].hasDistance())) {
                    // this.objs.push((new Obj(speed.value, this.h)));
                    this.objs.push((new Obj(lineSpeed * this.speed, this.h)));
                }
            }

            for (let i = 0; i < this.objs.length; i++) {
                this.objs[i].move();
                this.objs[i].display();
            }

            if (this.objs.length > 0) {
                for (let j = this.objs.length - 1; j >= 0; j--) {
                    if (this.objs[j].isFinished()) {
                        this.objs.splice(j, 1);
                    }
                }
            }
        }
    }

    class Obj {
        constructor(tmpSpeed, tmpH) {
            this.x = 0;
            this.y = 0;
            this.lineSpeed = tmpSpeed;
            this.w = sketch.random(10, 100); // 長方形長度
            this.h = tmpH;
            this.c = sketch.color(sketch.random(currentColorArr.arr));
        }

        move() {
            // (!this.speed) ? this.x -= 0.5 : this.x -= this.speed;
          this.x -= this.lineSpeed;
        }

        isFinished() {
          return (this.x < -MAX * 0.6 - this.w)
        }

        hasDistance() {
          return (this.x < -(this.w + DIST))
        }

        display() {
            sketch.fill(this.c);
            sketch.rect(this.x, this.y, this.w, this.h, this.h / 2);
        }
    }
    sketch.windowResized = function () {
		// sketch.resizeCanvas(sketch.windowWidth, sketch.windowHeight, true);
        cw = document.documentElement.clientWidth
		    ch = document.documentElement.clientHeight
        MAX = cw > ch ? cw  : ch;
        stWidth.value = 8 /defaultWidth * cw
		    sketch.resizeCanvas(cw, ch, true)
	}
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {
  if (n > 18000) { // 5min init
    initAnimate()
    canvasWrap.value = new p5(blossomAnimate, 'Blossom')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value = new p5(blossomAnimate, 'Blossom')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
    HighColors,
    LowColors,
    Colors,
    RingColor
  } = effectThemeData

  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''
  if (RingColor) stColor.value = rgbToHsb(RingColor)
  backgroundColor.value = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? changeToRgb(BackgroundColor) : 'rgb(0,0,0)'

  if (IsDynamicMode.toString() === 'false') {
    currentColorArr.arr = Colors.map(color => rgbToHsb(color))
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    colorHigh.value = HighColors
    colorLow.value = LowColors
    handleGetAnimateHSBAndSpeed(high.value, low.value, nowTemperature.value, colorHigh.value, colorLow.value)
  }
})

onMounted(() => {
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(blossomAnimate, 'Blossom')
})

onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  stColor.value = 'rgb(0,0,0)'
  backgroundColor.value = 'rgb(0,0,0)'
  animateSpeed.value = 10
  currentColorArr.arr = []
  high.value = null
  low.value = null
  colorHigh.value = []
  colorLow.value = []
  initAnimate()
})

</script>

<style lang="scss" scoped></style>
